/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { YookassaAmount } from "../../entities/yookassa/Amount";
import { z } from "zod/v4";

export const yookassaAmountSchema = z.object({
    "currency": z.optional(z.string()),
"value": z.optional(z.string())
    }) as unknown as z.ZodType<YookassaAmount>